import { Navigate } from "react-router-dom";
import { readSession } from '../_services/webSession';

export const PrivateRoute = ({ children }) => {
  try {
    const user = readSession();
    // Redirect if no user
    if (!user) {
      return <Navigate to="/login" replace />;
    }

    // Otherwise show the page
    return children;
  } catch (error) {
    console.error('PrivateRoute error:', error);
    return <Navigate to="/login" replace />;
  }
};
